import { GlobalStyleDefaults } from "manifest-components/src/Styles/globals";
import User from "manifest-core/classes/employerDashboard/user";
import { StaticDataList } from "manifest-core/api/b2c/APIUser";

export enum Actions {
  CHANGE_EMAIL = "CHANGE_EMAIL",
  CLEAR_DATA = "CLEAR_DATA",
  FETCHING_USER = "FETCHING_USER",
  GET_USER = "GET_USER",
  GET_USER_DETAILS = "GET_USER_DETAILS",
  GET_VERIFICATION_CODE_DELIVERY_METHOD = "GET_VERIFICATION_CODE_DELIVERY_METHOD",
  PASSWORD_CHANGED = "PASSWORD_CHANGED",
  SET_HEADER_CLASS = "SET_HEADER_CLASS",
  SET_SHOW_HAMBURGER_MENU = "SET_SHOW_HAMBURGER_MENU",
  SET_NAVIGATION_BLOCKED = "SET_NAVIGATION_BLOCKED",
  UPDATE_GLOBAL_CSS_VAR = "UPDATE_GLOBAL_CSS_VAR",
  SET_SHOW_FULL_SCREEN_LOADER = "SET_SHOW_FULL_SCREEN_LOADER",
  GET_STATES = "GET_STATES",
}

export type Action =
  | { type: Actions.SET_SHOW_FULL_SCREEN_LOADER; payload: boolean }
  | { type: Actions.SET_HEADER_CLASS; payload: string }
  | { type: Actions.CHANGE_EMAIL }
  | { type: Actions.CLEAR_DATA }
  | { type: Actions.FETCHING_USER }
  | { type: Actions.GET_USER; payload: User }
  | { type: Actions.GET_VERIFICATION_CODE_DELIVERY_METHOD; payload: string }
  | { type: Actions.PASSWORD_CHANGED }
  | { type: Actions.SET_NAVIGATION_BLOCKED; payload: string }
  | { type: Actions.SET_SHOW_HAMBURGER_MENU; payload: boolean }
  | {
      type: Actions.UPDATE_GLOBAL_CSS_VAR;
      payload: { property: keyof typeof GlobalStyleDefaults; value: any };
    }
  | { type: Actions.GET_STATES; payload: StaticDataList["staticDataList"] };
